export default __webpack_public_path__ + "static/media/tmonial13.d4004da1.jpg";